// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1mAfh","header":"ReportDetails_header__Iq0Ut","title":"ReportDetails_title__2BcdE","left":"ReportDetails_left__1j1sd"};